var map = {
	"./logo": 4,
	"./logo.png": 4,
	"./logo_basic": 5,
	"./logo_basic.jpg": 5,
	"./logo_dark_mode": 6,
	"./logo_dark_mode.png": 6,
	"./logo_flat": 7,
	"./logo_flat.png": 7,
	"./logo_login": 8,
	"./logo_login.png": 8,
	"./socialmedia": 9,
	"./socialmedia.jpg": 9
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;